import { validateClientEnv } from '@repo/env';

/**
 * Validated, typed environment variables for the web app.
 * Throws at startup if required vars are missing or malformed.
 *
 * Usage:
 *   import { env } from '@/env';
 *   const url = env.VITE_CONVEX_URL;
 */
export const env = validateClientEnv(import.meta.env);
